import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhatsInside } from './components/WhatsInside';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { WhyDifferent } from './components/WhyDifferent';
import { VisualExperience } from './components/VisualExperience';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Support } from './components/Support';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-black text-cream font-sans selection:bg-gold/30 selection:text-cream relative" data-id="element-0">
      {/* Global Noise Overlay for cinematic texture */}
      <div className="noise-overlay" data-id="element-1"></div>

      <Nav data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Problem data-id="element-5" />
        <WhatsInside data-id="element-6" />
        <Bonuses data-id="element-7" />
        <Pricing data-id="element-8" />
        <WhyDifferent data-id="element-9" />
        <VisualExperience data-id="element-10" />
        <Testimonials data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <Support data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}